(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/tab-scroller", [], factory);
	else if(typeof exports === 'object')
		exports["tab-scroller"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["tab-scroller"] = factory();
})(this, function() {
return 